import Import from './Import.vue'

export default Import
